module.exports = __webpack_public_path__ + "media/images/bg-auth-0c18bcb6131429528e0b8271d4311d06.jpg";